import CardWrapper from "../../HOC/card/card";
import "./profile.scss";
import CustomButton from "../../components/custom-button";
import { Form, Input } from "antd";

import CustomSelect from "../../components/custom-select";
import PageTitle from "../../HOC/page-title";
import CardHeader from "../../components/card-header";
import SectionTitle from "../../components/section-title";
import { useEffect } from "react";
const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const options = [
  { title: "ذكر", value: 1 },
  { title: "انثى", value: 2 },
];
const Profile = ({ handleChangeKey }) => {
  const onFinish = (values) => {
    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    handleChangeKey(2);
  }, []);
  const handleSave = () => {
    console.log("Success:dss");
  };
  return (
    <div className="profile-container">
      <CardWrapper>
        <div className="page-content">
          <Form
            {...layout}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <CardHeader title="معلومات الملف الشخصي">
              {/* the button that will appear at the left of the card  header*/}
              <CustomButton
                styles={{ width: "100%", height: "50px", fontSize:"24px", fontWeight:"800" }}
                title="حفظ"
                handleClick={handleSave}
                type="submit"
              />
            </CardHeader>
            <SectionTitle title="المعلومات الشخصية" />
            <Form.Item
              name="name"
              rules={[
                {
                  required: true,
                  message: "برجاء ادخال الاسم",
                },
              ]}
            >
              <div className="input-element">
                <label>الاسم</label>
                <Input placeholder="عبدالله محمد صالح"/>
              </div>
            </Form.Item>
            <Form.Item
              name="country"
              rules={[
                {
                  required: true,
                  message: "برجاء ادخال الدولة",
                },
              ]}
            >
              <div className="input-element">
                <label>الدولة</label>
                <Input placeholder="المملكة العربية السعودية "/>
              </div>
            </Form.Item>
            <Form.Item
            name="gender"
            rules={[
              {
                required: true,
                message: "برجاء ادخال الجنس",
              },
            ]}
          >
            <div className="input-element">
              <label>الجنس</label>
              <Input placeholder="ذكر "/>
            </div>
          </Form.Item>
         
            <Form.Item
              name="phone"
              rules={[
                {
                  required: true,
                  message: "برجاء ادخال رقم الجوال",
                },
              ]}
            >
              <div className="input-element">
                <label>رقم الجوال</label>
                <Input placeholder="+99521454545"/>
              </div>
            </Form.Item>
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: "برجاء ادخال البريد الإلكتروني",
                  type: "email",
                },
              ]}
            >
              <div className="input-element">
                <label>البريد الإلكتروني</label>
                <Input placeholder="Abdallahsaleh@gmail.com" />
              </div>
            </Form.Item>

            <div className="password-section-change">
                 
                 <SectionTitle title="كلمة المرور" />

                 <Form>
                      <Form.Item
                            name="password"
                            rules={[
                              {
                                required: true,
                                message: "برجاء ادخال كلمة المرور صحيحة",
                                type: "password",
                              },
                            ]}
                          >
                            <div className="input-element">
                              <label>كلمة المرور</label>
                              <Input type="password" placeholder=".........." />
                          </div>
                     </Form.Item>
                     <Form.Item
                          name="password"
                          rules={[
                            {
                              required: true,
                              message: "برجاء ادخال كلمة المرور صحيحة",
                              type: "password",
                            },
                          ]}
                        >
                          <div className="input-element">
                            <label>تأكيد كلمة المرور</label>
                            <Input type="password" placeholder=".........." />
                        </div>
                    </Form.Item>
                 </Form>


                {/* 
                <Form>
                      <Form.Item
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: "برجاء ادخال كلمة المرور",
                          },
                        ]}
                      >
                        <div className="input-element">
                          <label>كلمة المرور</label>
                          <Input.Password className="password-c"/>
                        </div>
                      </Form.Item>
                      <Form.Item
                        name="confirmPassword"
                        dependencies={["password"]}
                        rules={[
                          {
                            required: true,
                            message: "برجاء ادخال كلمة المرور",
                          },
                          ({ getFieldValue }) => ({
                            validator(rule, value) {
                              if (!value || getFieldValue("password") === value) {
                                return Promise.resolve();
                              }

                              return Promise.reject("كلمتي المرور غير متطابقتين");
                            },
                          }),
                        ]}
                      >
                        <div className="input-element">
                          <label></label>
                          <Input.Password />
                        </div>
                      </Form.Item>
                
                </Form>
                */}
               
            </div>

          
          </Form>
        </div>
      </CardWrapper>
    </div>
  );
};

export default PageTitle(Profile);
